import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axios/axiosInstance";
import { setResultModalData, showModal } from "../modal/modalSlice";

const initialState = {
    //! alt kullanıcı listesi
    subUserList: [],
    //! seçilen alt kullanıcı
    selectedUser: null,
    //! sahip olabileceği tüm yetkiler
    claimList: [],
    //! kullanıcının yetkileri
    userClaims: null,
    adminOrUserClaims: null,

    updatedAuthorizationList: [],

    isLoadingAddSubUser: false,
    isLoadingGetSubUsers: false,
    isLoadingGet: false,
    isLoadingAltKullaniciStatus: false,
}


//! altKullaniciEkle
  export const addSubUser = createAsyncThunk("companyAuth/addSubUser", async(body, thunkApi) => {
    try{
      const {data} = await axiosInstance.post(`Auth/SubUserCompany`, body)

      if(data?.statusCode === 200){
        thunkApi.dispatch(showModal("result"))
        thunkApi.dispatch(setResultModalData({msg: "Kullanıcı başarıyla eklendi.", resultType: "success", btnText1: "Listeyi Görüntüle"}))
      }

      return data.data
    }catch(error){
      thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
      return thunkApi.rejectWithValue(error)
    }
  })

  //! getSubUsers
  export const getSubUsers = createAsyncThunk("companyAuth/getSubUsers", async(_, thunkApi) => {
    try{
      const {data} = await axiosInstance.get(`Auth/GetSubUserCompanies`)
      return data.data
    }catch(error){
      return thunkApi.rejectWithValue(error)
    }
  })

  //! alt kullanıcı durum değiştirme aktif/pasif
  export const changeStatusSubUser = createAsyncThunk("companyAuth/changeStatusSubUser", async( body, thunkApi) => {
    try{
      const {data} = await axiosInstance.post(`User/DeleteAccountUser`, body)
      
      if(data?.statusCode === 200){
        thunkApi.dispatch(showModal("result"))
        thunkApi.dispatch(setResultModalData({msg: "Kullanıcı durumu değiştirildi.", resultType: "success", btnText1: "Listeyi Görüntüle"}))
      }
      
      return data.data
    }catch(error){
      return thunkApi.rejectWithValue(error)
    }
  })

  //! sahip olabileceği tüm yetkiler
  export const getAllClaims = createAsyncThunk("companyAuth/getAllClaims", async(_, thunkApi) => {
    try{
      const {data} = await axiosInstance.get(`UserPermission/GetAllClaims`)
      return data.data
    }catch(error){
      return thunkApi.rejectWithValue(error)
    }
  })

  //! kullanıcının yetkileri
  export const getUserClaims = createAsyncThunk("companyAuth/getUserClaims", async(id , thunkApi) => {
    try{
      const {data} = await axiosInstance.get(`UserPermission/GetUserClaims?${id ? `userId=${id}` : ""}`)
      
      return data.data
    }catch(error){
      return thunkApi.rejectWithValue(error)
    }
  })
  export const getAdminOrUserClaims = createAsyncThunk("companyAuth/getAdminOrUserClaims", async(id , thunkApi) => {
    try{
      const {data} = await axiosInstance.get(`UserPermission/GetAdminOrUserClaims?${id ? `userId=${id}` : ""}`)
      
      return data.data
    }catch(error){
      return thunkApi.rejectWithValue(error)
    }
  })

  //! yetki verme
  export const addClaims = createAsyncThunk("companyAuth/addClaims", async(body , thunkApi) => {
    try{
      const {data} = await axiosInstance.post(`UserPermission/AddClaims`, body)
      if(data?.statusCode === 200){
        thunkApi.dispatch(showModal("result"))
        thunkApi.dispatch(setResultModalData({msg: "Kullanıcı yetkilendirmesi başarılı bir şekilde yapıldı.", resultType: "success", btnText1: "Listeyi Görüntüle"}))
      }
      return data.data
    }catch(error){
      thunkApi.dispatch(showModal("result"))
      thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] , resultType: "error", btnText1: "Listeyi Görüntüle"}))
      return thunkApi.rejectWithValue(error)
    }
  })
  
  //! şifre değiştirme apisi
export const changePassword = createAsyncThunk("User/changePassword", async(body, thunkApi) => {
  try{
      
      const {data} = await axiosInstance.post(`${process.env.REACT_APP_API_URI}/User/ChangePassword`, body)
      if(data.statusCode === 200){
          thunkApi.dispatch(showModal("result"))
          thunkApi.dispatch(setResultModalData({msg: "Şifreniz başarılı bir şekilde değiştirildi. Lütfen tekrar giriş yapınız.", btnText1: "Harika!", resultType: "success", routePath: "/giris-yap"}))
          localStorage.clear()
          sessionStorage.clear()
      }
      return data.data
  }catch(error){
      return thunkApi.rejectWithValue(error)
  }
})
  

const companyAuthorizationSlice = createSlice({
    name: "companyAuthorization",
    initialState,
    reducers: {

      //! işlem yapılacak alt kullanıcı seçimi
      setSelectedUser: (state, action) => {
        state.selectedUser = action.payload
      },

      //! yetki dizisi
      setUpdatedAuthorizationList: (state, action) => {
        state.updatedAuthorizationList = action.payload
      }
        
    },
    extraReducers:(builder)=> {
        builder
        //! alt kullanıcı ekleme
        .addCase(addSubUser.pending, (state)=> {
            state.isLoadingAddSubUser = true
        })
        .addCase(addSubUser.fulfilled, (state, action)=> {
            state.isLoadingAddSubUser = false
            state.subUserList = [...state.subUserList, action.payload]
        })

        .addCase(addSubUser.rejected, (state, action)=> {
            state.isLoadingAddSubUser = false
        })

        //! alt kullanıcıları getirme
        .addCase(getSubUsers.pending, (state)=> {
            state.isLoadingGetSubUsers = true
        })
        .addCase(getSubUsers.fulfilled, (state, action)=> {
            state.isLoadingGetSubUsers = false
            state.subUserList = action.payload.$values
        })

        .addCase(getSubUsers.rejected, (state, action)=> {
            state.isLoadingGetSubUsers = false
        })

        //! alt kullanıcı aktif pasif
        .addCase(changeStatusSubUser.pending, (state)=> {
          state.isLoadingAltKullaniciStatus = true
        })
        .addCase(changeStatusSubUser.fulfilled, (state, action)=> {
            state.isLoadingAltKullaniciStatus = false
            state.subUserList = state.subUserList.map((item) => {
              const shouldUpdate = item?.id === action.payload?.id
              if(shouldUpdate){
                return {
                  ...item, ...action.payload
                }
              }else{
                return item
              }
            })
        })

        .addCase(changeStatusSubUser.rejected, (state, action)=> {
            state.isLoadingAltKullaniciStatus = false
        })

        //! sahip olabileceği tüm yetkiler
        .addCase(getAllClaims.pending, (state)=> {
            state.isLoadingGet = true
        })
        .addCase(getAllClaims.fulfilled, (state, action)=> {
            state.isLoadingGet = false
            state.claimList = action.payload.$values
        })

        .addCase(getAllClaims.rejected, (state, action)=> {
            state.isLoadingGet = false
        })

        //! kullanıcının yetkileri
        .addCase(getUserClaims.pending, (state)=> {
          state.isLoadingGet = true
        })
        .addCase(getUserClaims.fulfilled, (state, action)=> {
            state.isLoadingGet = false
            state.userClaims = action.payload.$values
        })

        .addCase(getUserClaims.rejected, (state, action)=> {
            state.isLoadingGet = false
        })

        .addCase(getAdminOrUserClaims.pending, (state)=> {
          state.isLoadingGet = true
        })
        .addCase(getAdminOrUserClaims.fulfilled, (state, action)=> {
            state.isLoadingGet = false
            state.adminOrUserClaims = action.payload.$values
        })

        .addCase(getAdminOrUserClaims.rejected, (state, action)=> {
            state.isLoadingGet = false
        })

        //! şifre değiştirme apisi
        .addCase(changePassword.pending, (state)=> {
          state.isLoadingGet = true
      })
      .addCase(changePassword.fulfilled, (state, action)=> {
          state.isLoadingGet = false
      })

      .addCase(changePassword.rejected, (state, action)=> {
          state.isLoadingGet = false
      })
        
    }
})

export const {setSelectedUser, setUpdatedAuthorizationList} = companyAuthorizationSlice.actions
export default companyAuthorizationSlice.reducer